import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import SendOrderMessagePopup from "@/pages/comp/book_order/shop/order/popup/send_order_msg";
import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";
import getXcolumnJson from "./xcolumn/list";
import TopTabArea from "./area/top_tab";
import SearchArea from "./area/search";
import SumMoneyArea from "./area/sum_money";
import ManageArea from "./area/manage";
import OrderDetailRowArea from "./area/detail_row";
import OrderListExcelDown from "./area/excel_down";

function OrderListArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const [is_show_detail, set_is_show_detail] = useState(true);
  const OrderListExcelDownRef = useRef<any>(null);

  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_mcomp_seq: "",
    s_state: "request",
    s_date_type: "a_date",
    s_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_in_out: "out",
    s_title_like: "",
    s_user_name_like: "",
    s_mcomp_name_like: "",
    s_mcomp_group_seq: "",
    s_mcomp_sort_detail: "",
    s_mcomp_belong_sort: "",
    order_id: "a_date DESC, a_seq DESC",
    s_money_sum: "1",
    s_addon_mcomp: "1",
    s_addon_detail: "1",
    s_addon_payt: "1",
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  let select_order_state_arr = ShopFunc.select_order_state_arr;
  let select_in_out_arr = ShopFunc.select_in_out_arr;
  let select_pay_sort = ShopFunc.select_pay_sort;

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "write",
    has_header: true,
    mcomp_seq: "",
    order_seq_arr: [],
    msg_sort: "order_start_deliver",
    title: "팝업",
    width: "800px",
    height: "85%",
  });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      is_excel_down: false,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);
    if (tmp_list_opt.is_excel_down) {
      tmp_list_opt.is_paging = "";
    } else {
      tmp_list_opt.is_paging = "1";
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (tmp_list_opt.is_excel_down) {
            if (OrderListExcelDownRef.current) {
              OrderListExcelDownRef.current.goExcelDown({
                infoArr: response.data["data"]["info_arr"]
              });
            }
            return false;
          }
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
            setSelectbySelectedSeq({
              select_seq: tmp_list_opt.select_seq,
              info_arr: response.data["data"]["info_arr"],
            });
          }
        } else {

        }
      });
  };

  const setSelectbySelectedSeq = (inData: any) => {
    let opt_obj = {
      select_seq: "",
      info_arr: infoArr,
      ...inData
    };
    if (opt_obj.select_seq != "") {
      setTimeout(() => {
        if (ListComponentRef.current) {
          let active_row_arr: any = [];
          for (let i = 0; i < opt_obj.info_arr.length; i++) {
            let info = opt_obj.info_arr[i];
            if (info.row_pri_val == opt_obj.select_seq) {
              active_row_arr.push(true);
            } else {
              active_row_arr.push(false);
            }
          }
          ListComponentRef.current.set_active_row_arr(active_row_arr);
        }
      }, 100);
    }
  };

  const setWriteState = (inData: any) => {
    let opt_obj = {
      row_data: {},
      ...inData
    };
    ListComponentRef.current.set_active_row_arr([]);
  };

  const goDelete = (inData: any) => {
    let pre_selected_rows = ListComponentRef.current.getSelectedRows();
    let opt_obj = {
      selected_rows: pre_selected_rows,
      ...inData
    };
    let selected_rows = opt_obj.selected_rows;
    if (selected_rows.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_rows
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          setWriteState({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_cancel_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      change_state: "cancel",//cancel,destroy
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    let confrim_msg = "청구서를 취소하시겠습니까?(결제선생)";
    if (opt_obj["change_state"] == "destroy") {
      confrim_msg = "청구서를 파기하시겠습니까?(결제선생)";
    }
    if (confirm(confrim_msg) == false) {
      return false;
    }

    let order_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      order_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "order_seq_arr": order_seq_arr,
      change_state: opt_obj["change_state"],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/send_payt_cancel', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const get_payt_btn_render = (params: any) => {
    let render_str: any = "";

    if (params.rowData.a_pay_sort == "payt") {
      if (params.rowData["payt_supply"]) {
        render_str = (
          <div className="text-center">
            {params.rowData["payt_supply"]["a_state"] == "send" &&
              <>
                <button className="btn-s btn-red ml-1" onClick={() => {
                  setTimeout(() => {
                    send_payt_cancel_by_ajax({ change_state: "destroy" });
                  }, 100);
                }} >파기</button>
              </>
            }
            {params.rowData["payt_supply"]["a_state"] == "complete" &&
              <button className="btn-s btn-red ml-1" onClick={() => {
                setTimeout(() => {
                  send_payt_cancel_by_ajax({});
                }, 100);
              }} >결제취소</button>
            }
            <button className="btn-s btn-gray ml-1" onClick={() => {
              send_payt_send_read_by_ajax({ selected_row: [params.rowData] });
            }} >상태확인</button>
          </div>
        );
      }
    }

    return render_str;
  };

  const send_payt_send_read_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("청구서를 확인하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let order_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      order_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "order_seq_arr": order_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/send_payt_read', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const on_change_supply_row = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      row_data: {},
      ...inData
    };
    let name = opt_obj.name;
    let value = opt_obj.value;
    let row_data = opt_obj.row_data;

    if (strFunc.is_empty(row_data.a_seq)) {
      return false;
    }
    row_data[name] = value;

    let change_info_arr: any = [...infoArr];
    for (let i = 0; i < change_info_arr.length; i++) {
      let change_info: any = change_info_arr[i];
      if (change_info.a_seq == row_data.a_seq) {
        change_info_arr[i] = row_data;
      }
    }
    setInfoArr(change_info_arr);
    if (ListComponentRef.current) {
      ListComponentRef.current.setInfoArr(change_info_arr);
    }
    if (name == "a_deliver_invoice" || name == "a_deliver_company") {
      // update_change_order_by_ajax({
      //   change_order_arr: [row_data]
      // });
    }
  };

  const update_change_order_by_ajax = (inData: any) => {
    let opt_obj = {
      change_order_arr: [],
      ...inData
    };
    let change_order_arr = [];
    if (opt_obj.change_order_arr) {
      for (let i = 0; i < opt_obj.change_order_arr.length; i++) {
        let change_order = opt_obj.change_order_arr[i];
        if (!strFunc.is_empty(change_order.a_seq)) {
          change_order_arr.push(change_order);
        }
      }
    }
    if (change_order_arr.length === 0) {
      return false;
    }

    let form_data = {
      data_arr: change_order_arr,
      is_update: "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/write', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {

        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_send_order_msg_popup = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let order_seq_arr = [];
    for (let i = 0; i < opt_obj.selected_row.length; i++) {
      let tmp_row = opt_obj.selected_row[i];
      order_seq_arr.push(tmp_row["row_pri_val"]);
    }

    if (order_seq_arr.length === 0) {
      alert("선택된 주문이 없습니다.");
      return false;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      title: "배송시작 메세지 발송",
      sort: "send_order_msg",
      msg_sort: "order_start_deliver",
      order_seq_arr: order_seq_arr,
      width: "80%",
      height: "80%",
      has_header: true,
    });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    if (params.key === "row_view_amount") {
      if (params.rowData.order_det_amount) {
        params.value = strFunc.comma(params.rowData.order_det_amount);
      }
    } else if (params.key === "row_view_price") {
      if (params.rowData.order_det_price) {
        params.value = strFunc.comma(params.rowData.order_det_price);
      }
    } else if (params.key === "row_view_in_out") {
      let find_obj = select_in_out_arr.find((el: any) => el.value == params.rowData.a_in_out);
      if (find_obj) {
        params.value = find_obj.text;
      }
    } else if (params.key === "row_view_state") {
      let find_obj = select_order_state_arr.find((el: any) => el.value == params.rowData.a_state);
      if (find_obj) {
        params.value = find_obj.text;
      }
    } else if (params.key === "row_view_payt_sort") {
      let pay_sort_str = "";
      for (let i = 0; i < select_pay_sort.length; i++) {
        if (select_pay_sort[i].value == params.rowData.a_pay_sort) {
          pay_sort_str = select_pay_sort[i].text;
        }
      }
      params.value = (
        <div>
          {pay_sort_str}
        </div>
      );
    } else if (params.key === "row_view_req_comp_name") {
      if (params.rowData.mcomp_name) {
        params.value = params.rowData.mcomp_name;
      }
    } else if (params.key == "row_view_detail_title") {
      params.value = (
        <OrderDetailRowArea
          row_data={params.rowData}
          is_show_detail={is_show_detail}
        ></OrderDetailRowArea>
      );
    } else if (params.key == "row_view_payt_btn") {
      params.value = get_payt_btn_render(params);
    } else if (params.key == "row_view_invoice") {
      params.value = (
        <div>
          <div>
            <input type='text' className='row-input' name="a_deliver_company" value={params.rowData.a_deliver_company}
              placeholder='배송업체'
              autoComplete='off'
              onChange={(e: any) => {
                on_change_supply_row({
                  name: "a_deliver_company",
                  value: e.target.value,
                  row_data: params.rowData,
                });
              }}
              onBlur={() => {
                update_change_order_by_ajax({ change_order_arr: [params.rowData] });
              }} />
          </div>
          <div className='mt-1'>
            <input type='text' className='row-input' name="a_deliver_invoice" value={params.rowData.a_deliver_invoice}
              placeholder='송장번호'
              autoComplete='off'
              onChange={(e: any) => {
                on_change_supply_row({
                  name: "a_deliver_invoice",
                  value: e.target.value,
                  row_data: params.rowData,
                });
              }}
              onBlur={() => {
                update_change_order_by_ajax({ change_order_arr: [params.rowData] });
              }} />
          </div>
        </div>
      );
    }

    return params.value;
  };

  return (
    <div>
      <div style={{ minWidth: "500px" }}>
        <div>
          <TopTabArea
            listOpt={listOpt}
            setListOpt={setListOpt}
            list={list}
          ></TopTabArea>
        </div>
        <div className='mt-2'>
          <SearchArea
            listOpt={listOpt}
            setListOpt={setListOpt}
            list={list}
            goDelete={goDelete}
            is_show_detail={is_show_detail}
            set_is_show_detail={set_is_show_detail}
          ></SearchArea>
        </div>
        <div className='mt-1'>
          <SumMoneyArea
            countInfo={countInfo}
          ></SumMoneyArea>
        </div>
        <div className='mt-1'>
          <ManageArea
            listOpt={listOpt}
            list={list}
            open_send_order_msg_popup={open_send_order_msg_popup}
            ListComponentRef={ListComponentRef}
          ></ManageArea>
        </div>
        <div className="mt-1">
          <ListComponent
            ref={ListComponentRef}
            xColumnArr={{ ...xColumnArr }}
            gridOpt={{
              fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
              is_add_idx_num: false,
              is_add_checkbox: true,
              td_align: "center",
              height: "auto",
              is_fix_width: true,
              rowMultiSelectWithClick: false,
              onGridReady: () => {

              },

              is_all_select_row_key: true,
              rowOnClick: rowOnClick,
              customCellRenderer: customCellRenderer,
              class_name_json: {
                table_div: "basic_list_div",
                td_div: "row-col-div",
                input_check: "chk_row",
                row_input: "row-input",
                data_row_tr: "data_row_tr",
                active_row: "active",
                empty_con_div: "list_empty_content_div",
              },
            }}
          ></ListComponent>
        </div>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          is_view_num_per_page={true}
          is_show_total_rec={true}
          onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      </div>
      <OrderListExcelDown
        ref={OrderListExcelDownRef}
        infoArr={infoArr}
      ></OrderListExcelDown>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort === "send_order_msg" &&
            <SendOrderMessagePopup
              order_seq_arr={popupData.order_seq_arr}
              msg_sort={popupData.msg_sort}
              callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SendOrderMessagePopup>
          }
        </LayerPopup>
      }
    </div>
  );
}

export default OrderListArea;